import { render, staticRenderFns } from "./Trustees.vue?vue&type=template&id=2e227d0f"
import script from "./Trustees.vue?vue&type=script&lang=js"
export * from "./Trustees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports